import { SpaceBooking } from 'components/SpaceBooking/types';
import Image from 'next/image';
interface Props {
    booking: SpaceBooking;
}

export const SpaceBookingPreviewComponent = ({ booking }: Props) => {
    return (
        <div className={`tw-flex tw-items-center tw-gap-2 tw-p-0 ${booking.cancelled_at && 'tw-color-error'}`}>
            <div className="tw-max-h-7 tw-max-w-7">
                {booking?.user_image && (
                    <Image
                        src={
                            booking?.user_image
                                ? `${process.env.NEXT_PUBLIC_API_HOST}image/${booking.user_image}`
                                : undefined
                        }
                        width={30}
                        height={30}
                        alt={booking.user_name}
                        className="tw-aspect-square tw-rounded-full"
                    />
                )}
            </div>
            <div>
                <div className="">{booking.user_name}</div>
                <div className="tw-text-[0.65rem]"># {booking.id}</div>
                <div className="tw-text-[0.65rem]">{booking.user_email}</div>
                <div className="tw-text-[11px]">{booking.subscription?.title}</div>
            </div>
        </div>
    );
};
